import React from "react";
import { currencies } from "_constants";
import PropTypes from "prop-types";

import TitledInputDropdown from "components/TitledInputDropdown";

import styles from "forms/forms.css";

const CurrencyField = ({
  field: { name, value },
  form: { errors, setFieldValue, submitCount },
  label,
}) => (
  <div className={styles.field}>
    <TitledInputDropdown
      dropdownValue={value.currency || currencies[0]}
      dropdownValues={currencies}
      isRequired={!!submitCount && errors[name]}
      onInput={(v) => setFieldValue(name, { ...value, value: v })}
      onSelect={(currency) => setFieldValue(name, { ...value, currency })}
      title={label}
      value={value.value}
      isEdit
    />
  </div>
);

CurrencyField.propTypes = {
  label: PropTypes.string,
  field: PropTypes.shape({
    value: PropTypes.object,
    name: PropTypes.string,
  }),
  form: PropTypes.shape({
    submitCount: PropTypes.number,
    errors: PropTypes.object,
    setFieldValue: PropTypes.func,
  }),
};

export default CurrencyField;
